import { Pagination, PaginationProps } from 'antd';
import { NextArrow, PrevArrow } from '@/assets/icons';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { LIMIT_POSTS } from '@/constants/post';
import { BigThumbnailPostCard } from '../Shared/PostCard';
import { IPostWrapper } from '@/interfaces/wrapper';

export interface IVerticalPaginationWrapper extends IPostWrapper {
  totalCount?: number;
}

const VerticalPaginationWrapper = ({
  data,
  totalCount,
}: IVerticalPaginationWrapper) => {
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return (
        <div className="flex items-center justify-center w-full h-full">
          <PrevArrow className="w-[5px] h-[10px] fill-black " />
        </div>
      );
    }
    if (type === 'next') {
      return (
        <div className="flex items-center justify-center w-full h-full">
          <NextArrow className="w-[5px] h-[10px] fill-black " />
        </div>
      );
    }
    return originalElement;
  };

  const router = useRouter();
  const { query } = router;
  const [pageCurrent, setPageCurrent] = useState(1);
  useEffect(() => {
    query?.page && totalCount
      ? parseInt(query?.page as string) <= Math.ceil(totalCount / LIMIT_POSTS)
        ? setPageCurrent(parseInt(query?.page as string))
        : router.push({ query: { ...query, page: '1' } })
      : setPageCurrent(1);
  }, [query, query?.page, router, totalCount]);

  const handleChangePage = (page: number) => {
    router.push({
      query: {
        ...query,
        page: page,
      },
    });
  };

  return (
    <div>
      <div className="flex flex-col gap-5 my-4">
        {data?.slice(0, 8)?.map((post, index) => {
          return <BigThumbnailPostCard {...post} horizontal key={index} />;
        })}
      </div>

      <Pagination
        current={pageCurrent}
        defaultPageSize={LIMIT_POSTS}
        total={totalCount}
        itemRender={itemRender}
        showSizeChanger={false}
        onChange={page => handleChangePage(page)}
      />
    </div>
  );
};

export default VerticalPaginationWrapper;
